import close from './images/close.svg';
import error from './images/error.svg';
import information from './images/information.svg';
import pending from './images/pending.svg';
import success from './images/success.svg';
import warning from './images/warning.svg';

export default {
    close,
    error,
    information,
    pending,
    success,
    warning,
};
